import { AHButton, Box } from "arkh";
import React, { useCallback, useState } from "react";

import { WidgetSizeIndicator } from "./WidgetSizeIndicator";

import { WASizePreviewProps } from "./WASizePreviewProps";
import { useWASizePreviewSize } from "./useWASizePreviewSize";

import { WASizePreviewViewabilityConfig } from "./WASizePreviewViewabilityConfig";
import { FlashList } from "@shopify/flash-list";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WAPreviewContainer } from "@/src/features/Storecast/Storecast/WidgetAdd/WAPreviewContainer";
import { WAFakeHeader } from "@/src/features/Storecast/Storecast/WidgetAdd/WAFakeHeader";
import { widgetAddSizeGreaterOrEqualTo } from "../utils/widgetAddSizeGreaterOrEqualTo";

export const WASizePreviewRegularScale = 0.62;

export function WASizePreviewRegular(props: WASizePreviewProps) {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const { size, onViewableItemsChanged, scrollIndex } = useWASizePreviewSize({
    widgetSizes: props.widgetSizes,
    maxSize: props.maxSize,
    defaultSize: props.defaultSize,
  });
  const intl_token = useIntlTokens();

  const renderItem = useCallback(
    ({ item }: { item: (typeof props.widgetSizes)[number] }) => {
      return (
        <Box
          style={{
            alignItems: "center",
            justifyContent: "center",
            width,
            overflow: "hidden",
          }}
        >
          <WAPreviewContainer
            h={item.h}
            w={item.w}
            unitSize={props.unitSize}
            scale={WASizePreviewRegularScale}
          >
            {typeof props.children === "function"
              ? props.children(item)
              : props.children}
          </WAPreviewContainer>
        </Box>
      );
    },
    [props, width]
  );

  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      {props.hideHeader ? null : (
        <WAFakeHeader title={intl_token.Preview} headerLeftType={null} />
      )}
      <Box style={{ flex: 1 }} space="medium">
        <Box
          space="large"
          cornerRadius="large"
          style={{
            flex: 1,
            borderWidth: 1,
          }}
          color="surface"
          borderColor="border-primary"
        >
          <Box
            style={{ flex: 1 }}
            onLayout={(e) => {
              setHeight(e.nativeEvent.layout.height);
              setWidth(e.nativeEvent.layout.width);
            }}
          >
            {width > 0 && height > 0 ? (
              <FlashList
                horizontal
                scrollEnabled={props.widgetSizes.length > 1}
                pagingEnabled
                initialScrollIndex={scrollIndex}
                viewabilityConfig={WASizePreviewViewabilityConfig}
                onViewableItemsChanged={onViewableItemsChanged}
                showsHorizontalScrollIndicator={false}
                renderItem={renderItem}
                data={props.widgetSizes}
                contentContainerStyle={{
                  alignItems: "center",
                }}
              />
            ) : null}
          </Box>
          <Box spaceHorizontal="large">
            <Box spaceVertical="medium">
              <WidgetSizeIndicator
                currentSize={size}
                maxSize={props.maxSize}
                widgetSizes={props.widgetSizes}
              />
            </Box>
            <AHButton
              disabled={
                props.disabled ||
                !widgetAddSizeGreaterOrEqualTo(props.maxSize, size)
              }
              themeType="primary"
              title={
                !widgetAddSizeGreaterOrEqualTo(props.maxSize, size)
                  ? intl_token.NotEnoughSpace
                  : intl_token.Add
              }
              style={{ alignSelf: "stretch" }}
              onPress={() => props.onCreate(size)}
              loading={props.loading}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
